import axios from "./index.service";

export default class PaymentService {
  static documentPayment(payload) {
    return axios({
      method: "POST",
      url: `/api/services/v1/payments/`,
      data: payload,
    });
  }

  static verifyPayment(payload) {
    const { transactionRef, partnerRef } = payload;
    return axios({
      method: "GET",
      url: `/api/services/v1/payments/payment-callback`,
      params: {
        transactionRef: transactionRef,
        partnerRef: partnerRef,
      },
    });
  }

  static getCurrencyCodes() {
    return axios({
      method: "GET",
      url: `/api/services/v1/transactions/currencyCodes`,
    });
  }

  static feePayment(payload) {
    return axios({
      method: "POST",
      url: `/api/services/v1/payments/`,
      data: payload,
    });
  }
}
